import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "../styles/specialitytopics.css";
import SearchBanner from "../components/veterinaryconditions/SearchBanner";
import config from "../config/config";
var Settings = require("../components/settings.json");

const SpecialityTopics = (props) => {
  let params = useParams();
  const [specialityId] = useState(params.id);
  const [specialityList, setSpecialityList] = useState([]);
  const url =
    config.BASE_URL + Settings["loadSpecialityWiseUrl"] + specialityId;
  const logInResponse = useSelector((state) => state.loginReducer);
  const userEmail = logInResponse.isLoggedIn ? logInResponse.email : "null";

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(url, {
        params: {
          email: userEmail,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setSpecialityList(response.data.response);
        } else {
          throw new Error("Something went wrong ...");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [userEmail, url]);

  return (
    <div className="specialty">
      <SearchBanner />
      <div className="condition-card-open">
        <h4>{props.location.state}</h4>
        {specialityList.map((spc, i) => {
          return (
            <div className="topic-line" key={"condition-card-line" + i}>
              {/* {spc.topicLocked && <i className="fa fa-lock topic-locked"></i>} */}
              <i
                className={`fa ${
                  spc.topicLocked
                    ? "fa-lock topic-locked"
                    : "fa-unlock topic-unlocked"
                }`}
              ></i>
              <Link
                className="condition-card-line"
                to={`/topic/${props.location.state.replace(
                  /[^a-zA-Z0-9]/g,
                  "-"
                )}/${spc.id}`}
              >
                {spc.title}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SpecialityTopics;
